import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Row, Col, Card } from 'react-bootstrap';
import { BarChart, LineChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { AccountbilityApi } from "../../app/api/accountbility.api";



export function OrderCard1()
{
    const stats = AccountbilityApi(); 
  
    const fetchData = async () => { 
      const {data} = await stats.getOrderStatOfYear();
      return data.data; 
    }
    const { isLoading, data=[], error } = useQuery({  queryKey: ["orderChart1"], queryFn: fetchData });


    return(
   
        <Row className="mb-2">
          <Col xs={12} className='px-0'>
            <Card className="chart-card border">
            { 
              ( isLoading ) ? (
                <Card.Body>
                  <div className="d-flex flex-column align-items-center gap-3 py-5">
                    <div className="spinner-border text-green mb-3" style={{ width: '6rem', height: '6rem' }}></div>
                    <p className="text-secondary"> Chargement en cours... </p>
                  </div>
                </Card.Body>
              ) : (
                <Card.Body>

                  <span className="text-muted mb-4"> Montant généré par mois - Année 2025 </span>
                  <ResponsiveContainer width="100%" height={460}>
                    <LineChart data={data} margin={{ top: 40, right: 30, left: 0, bottom: 20 }}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#e9ecef" />
                      <XAxis dataKey="month" tick={{ fill: '#6c757d', fontSize: 12 }} />
                      <YAxis tick={{ fill: '#6c757d', fontSize: 12 }} />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: '#fff',
                          border: '1px solid #dee2e6',
                          borderRadius: '4px',
                        }}
                        formatter={(value) => `${value.toLocaleString()} €`}
                      />
                      <Legend wrapperStyle={{ paddingTop: '20px' }} />
                      <Line 
                        type="monotone" 
                        dataKey="totalAmount" 
                        stroke="#faab2c" 
                        strokeWidth={3}
                        dot={{ fill: '#faab2c', r: 5 }}
                        activeDot={{ r: 7 }}
                        name="Montant"
                      />
                    </LineChart>
                  </ResponsiveContainer>

                </Card.Body>
              )
            }
            {
              (error) && (
                  <Card.Body>
                    <div className="text-center p-4 border alert alert-danger w-100">
                      Une erreur est survenue. Vueiller vérifier votre connexion 
                    </div>
                  </Card.Body>
              )
            }
            </Card>
          </Col>
        </Row>
    )
}



export function OrderCard2()
{
    const stats = AccountbilityApi(); 
  
    const fetchData = async () => { 
      const {data} = await stats.getOrderStatOfYears();
      return data.data; 
    }
    const { isLoading, data=[], error } = useQuery({  queryKey: ["orderChart2"], queryFn: fetchData });


    return(
   
        <Row className="mb-2">
          <Col xs={12} className='px-0'>
            <Card className="chart-card border">
            { 
              ( isLoading ) ? (
                <Card.Body>
                  <div className="d-flex flex-column align-items-center gap-3 py-5">
                    <div className="spinner-border text-green mb-3" style={{ width: '6rem', height: '6rem' }}></div>
                    <p className="text-secondary"> Chargement en cours... </p>
                  </div>
                </Card.Body>
              ) : (
                <Card.Body>

                  <span className="text-muted mb-4"> Montant généré par année - Les 10 Dernières Années </span>
                  <ResponsiveContainer width="100%" height={460}>
                    <BarChart data={data} margin={{ top: 40, right: 30, left: 0, bottom: 20 }}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#e9ecef" />
                      <XAxis dataKey="year" tick={{ fill: '#6c757d', fontSize: 12 }} />
                      <YAxis tick={{ fill: '#6c757d', fontSize: 12 }} />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: '#fff',
                          border: '1px solid #dee2e6',
                          borderRadius: '4px',
                        }}
                        formatter={(value) => `${value.toLocaleString()} €`}
                      />
                      <Bar dataKey="totalAmount" fill="#f4c376" radius={[8, 8, 0, 0]} name="Montant" />
                      <Legend wrapperStyle={{ paddingTop: '20px' }} />
                    </BarChart>
                  </ResponsiveContainer>
                  

                </Card.Body>
              )
            }
            {
              (error) && (
                  <Card.Body>
                    <div className="text-center p-4 border alert alert-danger w-100">
                      Une erreur est survenue. Vueiller vérifier votre connexion 
                    </div>
                  </Card.Body>
              )
            }
            </Card>
          </Col>
        </Row>
    )
}






export function MaintenanceCard1()
{
    const stats = AccountbilityApi(); 
  
    const fetchData = async () => { 
      const {data} = await stats.getMaintenanceStatOfYear();
      return data.data; 
    }
    const { isLoading, data=[], error } = useQuery({  queryKey: ["maintenanceChart1"], queryFn: fetchData });


    return(
   
        <Row className="mb-2">
          <Col xs={12} className='px-0'>
            <Card className="chart-card border">
            { 
              ( isLoading ) ? (
                <Card.Body>
                  <div className="d-flex flex-column align-items-center gap-3 py-5">
                    <div className="spinner-border text-green mb-3" style={{ width: '6rem', height: '6rem' }}></div>
                    <p className="text-secondary"> Chargement en cours... </p>
                  </div>
                </Card.Body>
              ) : (
                <Card.Body>

                  <span className="text-muted mb-4"> Montant généré par mois - Année 2025 </span>
                  <ResponsiveContainer width="100%" height={460}>
                    <LineChart data={data} margin={{ top: 40, right: 30, left: 0, bottom: 20 }}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#e9ecef" />
                      <XAxis dataKey="month" tick={{ fill: '#6c757d', fontSize: 12 }} />
                      <YAxis tick={{ fill: '#6c757d', fontSize: 12 }} />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: '#fff',
                          border: '1px solid #dee2e6',
                          borderRadius: '4px',
                        }}
                        formatter={(value) => `${value.toLocaleString()} €`}
                      />
                      <Legend wrapperStyle={{ paddingTop: '20px' }} />
                      <Line 
                        type="monotone" 
                        dataKey="totalAmount" 
                        stroke="#838d96" 
                        strokeWidth={3}
                        dot={{ fill: '#838d96', r: 5 }}
                        activeDot={{ r: 7 }}
                        name="Montant"
                      />
                    </LineChart>
                  </ResponsiveContainer>

                </Card.Body>
              )
            }
            {
              (error) && (
                  <Card.Body>
                    <div className="text-center p-4 border alert alert-danger w-100">
                      Une erreur est survenue. Vueiller vérifier votre connexion 
                    </div>
                  </Card.Body>
              )
            }
            </Card>
          </Col>
        </Row>
    )
}



export function MaintenanceCard2()
{
    const stats = AccountbilityApi(); 
  
    const fetchData = async () => { 
      const {data} = await stats.getMaintenanceStatOfYears();
      return data.data; 
    }
    const { isLoading, data=[], error } = useQuery({  queryKey: ["maintenanceChart2"], queryFn: fetchData });


    return(
   
        <Row className="mb-2">
          <Col xs={12} className='px-0'>
            <Card className="chart-card border">
            { 
              ( isLoading ) ? (
                <Card.Body>
                  <div className="d-flex flex-column align-items-center gap-3 py-5">
                    <div className="spinner-border text-green mb-3" style={{ width: '6rem', height: '6rem' }}></div>
                    <p className="text-secondary"> Chargement en cours... </p>
                  </div>
                </Card.Body>
              ) : (
                <Card.Body>

                  <span className="text-muted mb-4"> Montant généré par année - Les 10 Dernières Années </span>
                  <ResponsiveContainer width="100%" height={460}>
                    <BarChart data={data} margin={{ top: 40, right: 30, left: 0, bottom: 20 }}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#e9ecef" />
                      <XAxis dataKey="year" tick={{ fill: '#6c757d', fontSize: 12 }} />
                      <YAxis tick={{ fill: '#6c757d', fontSize: 12 }} />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: '#fff',
                          border: '1px solid #dee2e6',
                          borderRadius: '4px',
                        }}
                        formatter={(value) => `${value.toLocaleString()} €`}
                      />
                      <Bar dataKey="totalAmount" fill="#a8b2ba" radius={[8, 8, 0, 0]} name="Montant" />
                      <Legend wrapperStyle={{ paddingTop: '20px' }} />
                    </BarChart>
                  </ResponsiveContainer>
                  

                </Card.Body>
              )
            }
            {
              (error) && (
                  <Card.Body>
                    <div className="text-center p-4 border alert alert-danger w-100">
                      Une erreur est survenue. Vueiller vérifier votre connexion 
                    </div>
                  </Card.Body>
              )
            }
            </Card>
          </Col>
        </Row>
    )
}




export function ExpenseCard1()
{
    const stats = AccountbilityApi(); 
  
    const fetchData = async () => { 
      const {data} = await stats.getExpenseStatOfYear();
      return data.data; 
    }
    const { isLoading, data=[], error } = useQuery({  queryKey: ["expenseChart1"], queryFn: fetchData });


    return(
   
        <Row className="mb-2">
          <Col xs={12} className='px-0'>
            <Card className="chart-card border">
            { 
              ( isLoading ) ? (
                <Card.Body>
                  <div className="d-flex flex-column align-items-center gap-3 py-5">
                    <div className="spinner-border text-green mb-3" style={{ width: '6rem', height: '6rem' }}></div>
                    <p className="text-secondary"> Chargement en cours... </p>
                  </div>
                </Card.Body>
              ) : (
                <Card.Body>

                  <span className="text-muted mb-4"> Montant généré par mois - Année 2025 </span>
                  <ResponsiveContainer width="100%" height={460}>
                    <LineChart data={data} margin={{ top: 40, right: 30, left: 0, bottom: 20 }}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#e9ecef" />
                      <XAxis dataKey="month" tick={{ fill: '#6c757d', fontSize: 12 }} />
                      <YAxis tick={{ fill: '#6c757d', fontSize: 12 }} />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: '#fff',
                          border: '1px solid #dee2e6',
                          borderRadius: '4px',
                        }}
                        formatter={(value) => `${value.toLocaleString()} €`}
                      />
                      <Legend wrapperStyle={{ paddingTop: '20px' }} />
                      <Line 
                        type="monotone" 
                        dataKey="totalAmount" 
                        stroke="#307072"
                        strokeWidth={3}
                        dot={{ fill: "#307072", r: 5 }}
                        activeDot={{ r: 7 }}
                        name="Montant"
                      />
                    </LineChart>
                  </ResponsiveContainer>

                </Card.Body>
              )
            }
            {
              (error) && (
                  <Card.Body>
                    <div className="text-center p-4 border alert alert-danger w-100">
                      Une erreur est survenue. Vueiller vérifier votre connexion 
                    </div>
                  </Card.Body>
              )
            }
            </Card>
          </Col>
        </Row>
    )
}



export function ExpenseCard2()
{
    const stats = AccountbilityApi(); 
  
    const fetchData = async () => { 
      const {data} = await stats.getExpenseStatOfYears();
      return data.data; 
    }
    const { isLoading, data=[], error } = useQuery({  queryKey: ["expenseChart2"], queryFn: fetchData });


    return(
   
        <Row className="mb-2">
          <Col xs={12} className='px-0'>
            <Card className="chart-card border">
            { 
              ( isLoading ) ? (
                <Card.Body>
                  <div className="d-flex flex-column align-items-center gap-3 py-5">
                    <div className="spinner-border text-green mb-3" style={{ width: '6rem', height: '6rem' }}></div>
                    <p className="text-secondary"> Chargement en cours... </p>
                  </div>
                </Card.Body>
              ) : (
                <Card.Body>

                  <span className="text-muted mb-4"> Montant généré par année - Les 10 Dernières Années </span>
                  <ResponsiveContainer width="100%" height={460}>
                    <BarChart data={data} margin={{ top: 40, right: 30, left: 0, bottom: 20 }}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#e9ecef" />
                      <XAxis dataKey="year" tick={{ fill: '#6c757d', fontSize: 12 }} />
                      <YAxis tick={{ fill: '#6c757d', fontSize: 12 }} />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: '#fff',
                          border: '1px solid #dee2e6',
                          borderRadius: '4px',
                        }}
                        formatter={(value) => `${value.toLocaleString()} €`}
                      />
                      <Bar dataKey="totalAmount" fill="#307072" radius={[8, 8, 0, 0]} name="Montant" />
                      <Legend wrapperStyle={{ paddingTop: '20px' }} />
                    </BarChart>
                  </ResponsiveContainer>
                  

                </Card.Body>
              )
            }
            {
              (error) && (
                  <Card.Body>
                    <div className="text-center p-4 border alert alert-danger w-100">
                      Une erreur est survenue. Vueiller vérifier votre connexion 
                    </div>
                  </Card.Body>
              )
            }
            </Card>
          </Col>
        </Row>
    )
}

